import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Data } from '../../components';
import placeholder from '../../assets/media/logo-mascot.svg';

const MediaItem = props => {
  const { link, logo, title, date } = props;

  const mediaLogo = logo || placeholder;

  return (
    <li className="press__mediaItem">
      <a
        href={link}
        className="press__mediaItem-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div
          className="press__mediaItem-logo"
          style={{ backgroundImage: `url(${mediaLogo})` }}
        />
        <div className="press__mediaItem-content">
          <h4 className="u-mb--remove u-textLarge">
            <Data>{title}</Data>
          </h4>
          <h5 className="u-mt--regular u-textMuted">
            {moment(date).format('LL')}
          </h5>
        </div>
      </a>
    </li>
  );
};

MediaItem.propTypes = {
  link: PropTypes.string.isRequired,
  logo: PropTypes.string,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
};

export default MediaItem;
